export class ReceptionHomeEntity{
    
    id:number;
    typeDocument:string;
    identification:string;
    name:string;
    lastName:string;
    phone:string;
    email:string;
    entity:string;
    eps:string;
    arl:string;
    visit:string;
    license:string;
    typeVisit:string;
    team:string;
    brand:string;
    serial:string;
    creationDate:string;
    userId:string;
    userIdUpdate:string;
    updateDate:string;
    userCreation:string;
    userUpdate:string;
    image:string;
    active:boolean;
    constructor (){}
}